import { notifications } from '@mantine/notifications';
import { IconMoodPuzzled } from '@tabler/icons-react';
import { useQuery } from '@tanstack/react-query';
import { Endpoints } from '@xver/apis';
import { useActiveProjectScope } from '@xver/hooks/useActiveProject';
import { isNetworkError } from '@xver/libs/connectionNotifier';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export function useOverviewQuery() {
    const { t } = useTranslation('dashboard');
    const hasShownError = useRef(false);
    const { activeProjectId, isResolved } = useActiveProjectScope();

    const { data, isPending, error, refetch } = useQuery({
        queryKey: ['api.v1.overview.get', activeProjectId],
        queryFn: async () => Endpoints.v1.Overview.getDashboard(),
        retry: 2,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
        staleTime: 0,
        gcTime: 1000 * 60 * 60 * 24,
        enabled: isResolved,
    });

    useEffect(() => {
        if (error && !isNetworkError(error) && !hasShownError.current) {
            hasShownError.current = true;
            notifications.show({
                title: t('overview.loadFailedTitle'),
                message: t('overview.loadFailedMessage'),
                icon: <IconMoodPuzzled size={32} color={'#eb5757'} />,
            });
        }
    }, [error, t]);

    return {
        data,
        isPending,
        refetch,
    };
}
